import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const steissueApi = createApi({
	reducerPath: "steissueApi",
	baseQuery: btBaseQuery,
	tagTypes: ["STEIssue"],

	endpoints: (builder) => ({
		getSTEIssues: builder.query<st_eissue[], string>({
			query: (cid) => `steissue/${cid}`,
			providesTags: ["STEIssue"],
		}),
		getSTEIssueById: builder.query<st_eissue, string>({
			query: (id) => `steissue/byid/${id}`,
			providesTags: ["STEIssue"],
		}),
		insertSTEIssue: builder.mutation({
			query: (steissue) => ({
				url: `/steissue/`,
				method: "POST",
				body: steissue,
			}),
			invalidatesTags: ["STEIssue"],
		}),
		updateSTEIssue: builder.mutation({
			query: (steissue) => ({
				url: `/steissue/`,
				method: "PUT",
				body: steissue,
			}),
			invalidatesTags: ["STEIssue"],
		}),
		deleteSTEIssue: builder.mutation({
			query: (steissue) => ({
				url: `/steissue/${steissue.is_id}`,
				method: "DELETE",
				body: steissue,
			}),
			invalidatesTags: ["STEIssue"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetSTEIssuesQuery,
	useGetSTEIssueByIdQuery,
	useInsertSTEIssueMutation,
	useUpdateSTEIssueMutation,
	useDeleteSTEIssueMutation,
} = steissueApi;
